import React from "react";

/**
 * Specification of props required to inject a "not found" fallback route into
 * the router.
 */
export type RouteErrorBoundaryProps = {
    /**
     * The callback that'll be triggered, where you should render your desired
     * error page.
     *
     * If you return a promise, then the router will wait for your component to
     * be ready for rendering. This makes it easy to implement code splitting
     * and deferred content loading.
     */
    render?(path: string, err: unknown): Promise<React.JSX.Element | null> | React.JSX.Element | null;
};

/**
 * Use the <RouteErrorBoundary ... /> component to declaratively inject an error
 * boundary, which will be rendered if something goes wrong during rendering of
 * something.
 */
// tslint:disable-next-line variable-name
export const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = () => null;
